import { TuiElasticContainer } from '@taiga-ui/layout';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Patient } from '@pixacare/domain';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { BehaviorSubject, first } from 'rxjs';
import { PatientEditComponent } from '../patient-edit/patient-edit/patient-edit.component';

@Component({
  selector: 'pxc-patient-create',
  templateUrl: './patient-create.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TuiElasticContainer, TranslocoDirective, PatientEditComponent, TuiButton, AsyncPipe],
})
export class PatientCreateComponent {
  private readonly context = inject<TuiDialogContext<Patient, Partial<PatientCreateComponent>>>(POLYMORPHEUS_CONTEXT);

  @Input() clientCode: string = this.context.data.clientCode;
  isPatientCreationFormValid$ = new BehaviorSubject<boolean>(false);
  patient: Patient;

  createPatient(): void {
    this.isPatientCreationFormValid$.pipe(first()).subscribe((isPatientFormValid) => {
      if (!isPatientFormValid) {
        return;
      }
      this.context.completeWith({ ...this.patient });
    });
  }

  cancel(): void {
    this.context.completeWith(null);
  }
}
